<template>
  <b-card>

    <b-form class="m-2">
      <validation-observer ref="userValidation">
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Tipo de Servicio" label-for="serviceType">
            <b-form-input id="serviceType" v-model="cranes.serviceType" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Período de Arrendamiento" label-for="leasePeriod">
            <b-form-input id="leasePeriod" v-model="cranes.leasePeriod" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Compañia" label-for="company">
            <b-form-input id="company" v-model="cranes.company" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Compañia de Seguro" label-for="insuranceCompany">
            <b-form-input id="insuranceCompany" v-model="cranes.insuranceCompany" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Poliza de Seguro" label-for="policy">
            <b-form-input id="policy" v-model="cranes.policy" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Número" label-for="number">
            <b-form-input id="number" v-model="cranes.number" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Placas" label-for="plates">
            <b-form-input id="plates" v-model="cranes.plates" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <b-form-group label="Cuadrilla" label-for="cfeTeam" >
            <v-select input-id="cfeTeam" :options="listTeams" :clearable="false" v-model="selectedTeam" v-if="listTeams"/>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Conductor" label-for="driver">
            <b-form-input id="driver" v-model="cranes.driver" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Teléfono conductor" label-for="driverPhone">
            <validation-provider #default="{ errors }" name="driverPhone" rules="required|digits:10">
            <cleave class="form-control" id="driverPhone" v-model="cranes.driverPhone" :state="errors.length > 0 ? false:null" name="driverPhone" :options="options.phoneMask" placeholder="Teléfono"/>
            <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      </validation-observer>
    </b-form>

    <!-- Action Buttons -->
    <div>
      <b-button type="submit" class="m-1" variant="primarySpore" @click="save()">{{$t('Labels.Save')}}</b-button>
      <b-button type="reset" class="m-1" variant="outline-danger" @click="cancel()">{{$t('Labels.Cancel')}}</b-button>
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */

import {
  BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import request from '@/libs/request/index'
import { app } from '@/main'
import { empty } from '@/libs/tools/helpers'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    BButton, BCard, BForm, BCol, BRow, vSelect, BFormGroup, BFormInput, Cleave, ValidationProvider, ValidationObserver
  },
  data () {
    return {
      listTeams: [{ title: '', value: '', label: '' }],
      selectedTeam: {},
      cranes: {
        teamUuid: '',
        number: '',
        plates: '',
        company: '',
        driver: '',
        driverPhone: '',
        insuranceCompany: '',
        policy: '',
        serviceType: '',
        leasePeriod: ''
      },
      options: {
        phoneMask: {
          blocks: [3, 3, 4],
          uppercase: true
        }
      }
    }
  },
  methods: {
    cancel () {
      this.teamUuid = ''
      this.number = ''
      this.plates = ''
      this.company = ''
      this.driver = ''
      this.driverPhone = ''
      this.insuranceCompany = ''
      this.policy = ''
      this.serviceType = ''
      this.leasePeriod = ''
      app.$router.push('/cranes')
    },
    async getTeams () {
      const params = {
        url: '/teams/list/all',
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          for (const item of data.data.data) {
            this.listTeams.push({
              title: item.name,
              value: item.uuid,
              label: item.name
            })
          }
        }
      })
    },
    validateEmpty () {
      if (empty(this.cranes.plates) || empty(this.cranes.number)) {
        this.$swal({
          title: this.$t('Messages.Fail'),
          text: this.$t('Messages.MissingParams'),
          icon: 'error'
        })
        return true
      }
    },
    async save () {
      if (!this.validateEmpty()) {
        this.cranes.teamUuid = this.selectedTeam.value
        const params = {
          url: '/cranes',
          method: 'POST',
          params: this.cranes
        }
        await request(params).then(data => {
          app.$router.push('/cranes')
        }).catch(err => {
          const errMsg = err?.response?.data?.error || err?.response?.data?.msg
          if (errMsg) {
            this.$swal({
              title: 'Error',
              text: errMsg,
              timer: 5000,
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-warning'
              },
              buttonsStyling: false
            })
          }
        })
      }
    },
    validationForm () {
      this.$refs.userValidation.validate().then(success => {
        if (success) {
          this.save()
        }
      })
    }
  },
  created () {
    this.getTeams()
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
